import { Typography } from "@mui/material";
import React from "react";

export default function Title({ children }) {
  return (
    <Typography
      variant="h5"
      fontWeight="medium"
      pb={1}
      sx={{
        textTransform: "uppercase",
        fontWeight: "bold",
        lineHeight: 1.5,
      }}
    >
      {children}
    </Typography>
  );
}
